// app/javascript/packs/stripe.js
import { Application } from "stimulus"
import StripePaymentController from "../controllers/stripe_payment_controller"
import StripeCardFormController from "../controllers/stripe_card_form_controller"

const application = Application.start()
application.register("stripe-payment", StripePaymentController)
application.register("stripe-card-form", StripeCardFormController)
